import Coze_src from '~/assets/images/partnerLogo/coze.png';
import jianying_src from '~/assets/images/partnerLogo/jianying.png';
import deepseek_src from '~/assets/images/partnerLogo/deepseek.png';
import huoshan_src from '~/assets/images/partnerLogo/huoshan.png';
import aliyun_src from '~/assets/images/partnerLogo/aliyun.png';
import tencent_src from '~/assets/images/partnerLogo/tencent.png';
import keling_src from '~/assets/images/partnerLogo/keling.jpg';
import vidu_src from '~/assets/images/partnerLogo/vidu.png';
import suno_src from '~/assets/images/partnerLogo/suno.webp';
import douyin_src from '~/assets/images/partnerLogo/douyin.webp';
import bilibili_src from '~/assets/images/partnerLogo/bilibili.jpeg';
import xiaohongshu_src from '~/assets/images/partnerLogo/xiaohongshu.jpg';
import kuaishou_src from '~/assets/images/partnerLogo/kuaishou.jpg';
import taobao_src from '~/assets/images/partnerLogo/taobao.png';
import xianyhu_src from '~/assets/images/partnerLogo/xianyhu.webp';

import './index.less';
const MarqueeSection = () => {
  const marqueeData = [
    {
      name: 'Coze',
      src: Coze_src,
    },
    {
      name: 'DeepSeek',
      src: deepseek_src,
    },
    {
      name: '阿里云',
      src: aliyun_src,
    },
    {
      name: '腾讯云',
      src: tencent_src,
    },
    {
      name: '剪映',
      src: jianying_src,
    },
    {
      name: '抖音',
      src: douyin_src,
    },
    {
      name: 'B站',
      src: bilibili_src,
    },
    {
      name: '小红书',
      src: xiaohongshu_src,
    },
    {
      name: '快手',
      src: kuaishou_src,
    },
    {
      name: '火山',
      src: huoshan_src,
    },
    {
      name: '淘宝',
      src: taobao_src,
    },
    {
      name: '闲鱼',
      src: xianyhu_src,
    },
    {
      name: '可灵',
      src: keling_src,
    },
    {
      name: 'Vidu',
      src: vidu_src,
    },
    {
      name: 'Suno',
      src: suno_src,
    },
  ];
  return (
    <section className="hp-partners-marquee-section">
      <div className="hp-partners-decorations">
        <div className="hp-partners-grid"></div>
        <div className="hp-partners-rays"></div>
        <div className="hp-partners-lines">
          <div className="hp-partners-line"></div>
          <div className="hp-partners-line"></div>
          <div className="hp-partners-line"></div>
        </div>
      </div>
      <div className="container">
        <div className="hp-partners-marquee-header">
          <h3 className="section-title">合作伙伴</h3>
          <p className="section-subtitle">
            共筑 <strong>AI</strong> 创新生态，携手迈向行业新未来
          </p>
        </div>
      </div>
      <div className="hp-partners-marquee-wrapper">
        <div className="hp-partners-marquee">
          <div className="hp-partners-marquee-inner">
            {marqueeData.map(({ name, src }, index) => (
              <div className="hp-partner-logo-item" key={`${index}-1`}>
                <img src={src} alt={name} />
              </div>
            ))}
            {marqueeData.map(({ name, src }, index) => (
              <div className="hp-partner-logo-item" key={`${index}-2`}>
                <img src={src} alt={name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default MarqueeSection;
